import { ROUTE_LOGIN } from '@1bill-app/constants';
import { AuthQuery } from '@1bill-app/services/auth/state/auth.query';
import { AuthService } from '@1bill-app/services/auth/state/auth.service';
import { getValidationMsgs } from '@1bill-app/validators/messages';
import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { KeyboardResize, Keyboard} from '@capacitor/keyboard';
import { Device } from '@capacitor/device';
import { IonInput, ModalController } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';
import { recoverPasswordForm } from '../create-account/form';
import { RecoverConfirmModalComponent } from './recover-confirm-modal/recover-confirm-modal.component';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.page.html',
  styleUrls: ['./recover-password.page.scss'],
})
export class RecoverPasswordPage implements OnInit {
  /* ui */
  public loading: boolean;
  public errorMsg: any;
  public showValidationError: boolean;
  /* Native keyboard property */
  public keyboardHeight = 0;
  public isNative = Capacitor.isNativePlatform();
  public isKeyboardShow: boolean;
  public serverValidationError: string = null;
  public userEmail: string = null;
  public showRecoverPasswordForm = true;
  verificationCodeDestination: string;
  /* form */
  @ViewChild('emailInput', { static: false }) emailInput: IonInput;
  recoverPasswordForm: FormGroup;
  validationMsgs = getValidationMsgs();
  enableNextBtn: boolean;

  constructor(
    private authService: AuthService,
    private authQuery: AuthQuery,
    private modalCtrl: ModalController,
    private logger: NGXLogger,
    private zone: NgZone,
    private router: Router,
  ) {
    this.recoverPasswordForm = recoverPasswordForm();
  }
  ngOnInit() {
    this.keyboardListener();
  }
  ionViewWillEnter() {
    if (Capacitor.isNativePlatform()) {
      Keyboard.setResizeMode({ mode: KeyboardResize.None });
    }
    setTimeout(() => this.emailInput.setFocus(), 400);
  }
  ionViewWillLeave() {
    if (Capacitor.isNativePlatform()) {
      Keyboard.setResizeMode({ mode: KeyboardResize.Native });
    }
  }

  get emailCtrl() {
    return this.recoverPasswordForm.get('email');
  }
  onEmailInputChange(e) {
    this.enableNextBtn = e.detail.value.length > 0 ? true : false;
  }
  async onRecoverPassword() {
    this.showValidationError = true;
    this.serverValidationError = null;
    this.recoverPasswordForm.markAllAsTouched();

    if (!this.recoverPasswordForm.valid) return;

    const { email } = this.recoverPasswordForm.value;
    this.errorMsg = null;
    this.loading = true;
    try {
      await this.authService.forgotPassword(email)
      .then((res) => {
        this.logger.log('FORGOT', res)
        this.verificationCodeDestination = res.CodeDeliveryDetails.Destination;
      })
      .catch((err) => {
        this.logger.error('this.authService.forgotPassword',err);
        if (err.code && err.code === 'UserNotFoundException') {
          this.serverValidationError = "An account with the given email doesn't exist.";
        } else {
          this.serverValidationError = err.message;
        }
        this.loading = false;
      });

      if (!this.serverValidationError) {
        this.userEmail = email;
        this.showRecoverPasswordForm = false;
        // const modal = await this.presentRecoverPasswordConfirmModal({ email });
        // modal.onWillDismiss().then(() => {
        //   this.authService.setLoading(false);
        //   this.authService.setCredentials({ email });
        //   this.router.navigate([ROUTE_LOGIN]);
        // });
      }
    } catch (err) {
      this.logger.warn(err);
      this.errorMsg = this.authQuery.getErrorMessage(err);
    } finally {
      this.loading = false;
      this.recoverPasswordForm.reset();
    }
  }

  backToRecoverPasswordForm(){
    this.showRecoverPasswordForm = true;
  }
  showCodeInputForm(){
    this.showRecoverPasswordForm = false;
  }

  completedReset(event) {
    const { email } = event;

    this.authService.setLoading(false);
    this.authService.setCredentials({ email });
    this.router.navigate([ROUTE_LOGIN]);
  }
  async presentRecoverPasswordConfirmModal(props: { email: string }) {
    const modal = await this.modalCtrl.create({
      component: RecoverConfirmModalComponent,
      cssClass: 'modal--auth-recover-confirm',
      componentProps: props,
    });
    await modal.present();
    return modal;
  }
  async keyboardListener() {
    const appInfo = await Device.getInfo();
    if (Capacitor.isNativePlatform()) {
      Keyboard.addListener('keyboardWillShow', (e) => {
        this.logger.debug('keyboardWillShow:', e);
        this.zone.run(() => {
          if (appInfo.platform === 'ios') {
            this.keyboardHeight = e.keyboardHeight;
          }
          this.isKeyboardShow = true;
        });
      });
      Keyboard.addListener('keyboardWillHide', () => {
        this.logger.debug('keyboardWillHide');
        this.zone.run(() => {
          this.keyboardHeight = 0;
          this.isKeyboardShow = false;
        });
      });
    }
  }

  get emailClass() {
    return (this.showValidationError && this.emailCtrl.invalid && this.emailCtrl.touched) ||
      this.serverValidationError
      ? 'error'
      : '';
  }
}
